import {
  CreateCompetenciesDocument,
  CreateCompetenciesMutation,
  CreateCompetenciesMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateCompetencies = () => {
  const [mutate, result] = useMutation(CreateCompetenciesDocument, {
    extractorFn: (data: CreateCompetenciesMutation) =>
      data.competenciesMutations.bulkCreateCompetenciesCompetency,
  })

  const createCompetencies = (
    competencies: CreateCompetenciesMutationVariables['competencies']
  ) => {
    return mutate({ variables: { competencies } })
  }

  return { createCompetencies, isLoading: result.loading }
}

export default useCreateCompetencies
